import { TargetSelector } from "@client/selectors";
import makeButton from "./Base/container";
import Container, { type ButtonContainerProps } from "./container";

export * from "./Base/selectors";

export { Container, makeButton };

export const ModuleButton = makeButton<ButtonContainerProps>(TargetSelector.Entity, "button");
export const ModuleSecondaryButton = makeButton<ButtonContainerProps>(TargetSelector.Entity, "secondaryButton");
